import { Toast as UIToast } from 'react-daisyui';
import { tProvidersProps } from '../../LayoutProvider/Layout.types';

export default function Toast(props: tProvidersProps) {
  const { children } = props;

  return (
    // Below the navbar, not over it: a toast that lands on the top-right
    // corner covers the controls that live there (the challenge chip, search)
    // and blocks their clicks for as long as it stays. The navbar publishes
    // its height as --LayoutPrivate-nav-height (see NotificationsSideBar).
    <UIToast
      vertical="top"
      horizontal="end"
      className="!z-[1000] max-w-[420px] !top-[var(--LayoutPrivate-nav-height,4rem)]"
    >
      {children}
    </UIToast>
  );
}
